import React from "react";
import { Link } from "react-router-dom";

// ===================================================================
// The Crowd v2 — Barre haute
//
// Remplace a la fois l'ancien en-tete et le menu de gauche de Hopin :
// logo et titre (retour a l'accueil), fil d'Ariane, choix du theme,
// utilisateur, deconnexion. Aucun appel API.
//
// Props :
//   filAriane      [{ libelle, to }] — le dernier element est la page
//                  courante (sans lien). Vide sur l'accueil.
//   nomUtilisateur, libelleRole
//   theme          "dark" | "light"
//   onThemeChange(theme)
//   onLogout()
// ===================================================================

function initiales(nom) {
  if (!nom) return "";
  return nom
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((mot) => mot[0].toUpperCase())
    .join("");
}

function BarreHaute({ filAriane = [], nomUtilisateur, libelleRole, theme, onThemeChange, onLogout }) {
  return (
    <header className="v2-barre">
      <Link to="/v2" className="v2-barre-marque">
        <img
          src="/Hopscotch-Square-Black_White-Typo.png"
          alt="Hopscotch"
          className="v2-barre-logo"
          onError={(e) => { e.target.style.display = "none"; }}
        />
        <span className="v2-barre-titre">The Crowd</span>
      </Link>

      {filAriane.length > 0 && (
        <nav className="v2-ariane" aria-label="Fil d'Ariane">
          <Link to="/v2" className="v2-ariane-lien">Accueil</Link>
          {filAriane.map((etape, i) => {
            const derniere = i === filAriane.length - 1;
            return (
              <React.Fragment key={etape.libelle}>
                <span className="v2-ariane-sep" aria-hidden="true">›</span>
                {derniere || !etape.to ? (
                  <span className="v2-ariane-courant" aria-current="page">{etape.libelle}</span>
                ) : (
                  <Link to={etape.to} className="v2-ariane-lien">{etape.libelle}</Link>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      )}

      <div className="v2-barre-espace" />

      <div className="v2-theme" role="group" aria-label="Thème">
        <button
          type="button"
          className={`v2-theme-choix${theme === "dark" ? " actif" : ""}`}
          aria-pressed={theme === "dark"}
          onClick={() => onThemeChange("dark")}
        >
          Sombre
        </button>
        <button
          type="button"
          className={`v2-theme-choix${theme === "light" ? " actif" : ""}`}
          aria-pressed={theme === "light"}
          onClick={() => onThemeChange("light")}
        >
          Clair
        </button>
      </div>

      <div className="v2-utilisateur">
        <span className="v2-avatar" aria-hidden="true">{initiales(nomUtilisateur)}</span>
        <span className="v2-utilisateur-texte">
          <span className="v2-utilisateur-nom">{nomUtilisateur}</span>
          {libelleRole && <span className="v2-utilisateur-role">{libelleRole}</span>}
        </span>
      </div>

      <button type="button" className="v2-btn-discret" onClick={onLogout}>
        Déconnexion
      </button>
    </header>
  );
}

export default BarreHaute;
